import { type Content, type SearchResult, type Space } from '@databases/types/confluence';

import { nextPagination } from '../pagination';

import { fetchConfluenceData, rejectOnError } from './fetch';

export function searchConfluence<T extends Content | Space>(
  cql: string,
  expand: string[] = [],
  limit = Infinity
): AsyncGenerator<SearchResult<T>, void, void> {
  return nextPagination<SearchResult<T>>(
    async (url) => {
      const res = await fetchConfluenceData(
        url ??
          `/rest/api/search?${new URLSearchParams({
            cql,
            expand: expand.map((e) => `content.${e}`).join(','),
            limit: `${Math.min(200, limit)}`
          })}`
      ).then(rejectOnError);
      return await res.json();
    },
    { limit }
  );
}
